import axios from 'axios'
import Constants from '../constants'

export default {
  searchStation: (name, lang) => {
    if (!lang) lang = 'ja'
    let url = Constants.API_MIXWAY_PATH + "point/light?key=" + Constants.API_KEY
    url += "&name=" + encodeURIComponent(name);
    url += "&language=" + lang

    return new Promise((resolve) => {
      axios.get(url)
        .then(payload => {
          const stations = payload.data.ResultSet.Point.map((point) => { return point.Station })
          resolve(stations)
        })
    })
  }
}
